import React from 'react';
import  imagess from '../../assets/images/services.jpg';
import  PageTitle from '../../Components/PageTitle';

function Services() {
	return (
		<>
        <PageTitle title="Services" />
            <div className='intergrated_parent'>
                <div className="integrated_metering_section">
                    <div className="background">
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="inner_area">
                                    <div className="row align-items-center">
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="image_area">
                                                <img src={imagess}  />
                                            </div>
                                        </div>
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="content_area">
                                                <div className="header_area">
                                                    <h4>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</h4>
                                                </div>
                                                <div className="content">
                                                    <p>
                                                    Lorem ipsum dolor, sit amet consectetur adipisicing elit. Commodi laboriosam maiores officiis dicta dolores quidem ducimus accusantium sed quas quibusdam corporis aliquam asperiores dignissimos reiciendis inventore, quasi soluta iste! Placeat.
                                                    Commodi laboriosam maiores officiis dicta dolores quidem ducimus accusantium sed quas quibusdam corporis aliquam asperiores dignissimos reiciendis inventore, quasi soluta iste! Placeat.
                                                    Commodi laboriosam maiores officiis dicta dolores quidem ducimus accusantium sed quas quibusdam corporis aliquam asperiores dignissimos reiciendis inventore, quasi soluta iste! Placeat.
                                                    Commodi laboriosam maiores officiis dicta dolores quidem ducimus accusantium sed quas quibusdam corporis aliquam asperiores dignissimos reiciendis inventore, quasi soluta iste! Placeat.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="integrated_metering_section msv">
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="inner_area">
                                    <div className="row align-items-center">
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 order-lg-0 order-1">
                                            <div className="content_area left">
                                                <div className="header_area align-right">
                                                    <h4>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</h4>
                                                </div>
                                                <div className="content align-right">
                                                    <p>
                                                    Lorem ipsum dolor, sit amet consectetur adipisicing elit. Commodi laboriosam maiores officiis dicta dolores quidem ducimus accusantium sed quas quibusdam corporis aliquam asperiores dignissimos reiciendis inventore, quasi soluta iste! Placeat.
                                                    Commodi laboriosam maiores officiis dicta dolores quidem ducimus accusantium sed quas quibusdam corporis aliquam asperiores dignissimos reiciendis inventore, quasi soluta iste! Placeat.
                                                    Commodi laboriosam maiores officiis dicta dolores quidem ducimus accusantium sed quas quibusdam corporis aliquam asperiores dignissimos reiciendis inventore, quasi soluta iste! Placeat.
                                                    Commodi laboriosam maiores officiis dicta dolores quidem ducimus accusantium sed quas quibusdam corporis aliquam asperiores dignissimos reiciendis inventore, quasi soluta iste! Placeat.
                                                    </p>
                                                </div>
                                            </div>   
                                        </div>
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="image_area">
                                                <img src={imagess} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="integrated_metering_section ">
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="inner_area">
                                    <div className="row align-items-center">
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div class="image_area">
                                                <img src={imagess}  />
                                            </div>
                                        </div>
                                        <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div class="content_area">
                                                <div class="header_area">
                                                    <h4>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</h4>
                                                </div>
                                                <div class="content">
                                                    <p>
                                                    Lorem ipsum dolor, sit amet consectetur adipisicing elit. Commodi laboriosam maiores officiis dicta dolores quidem ducimus accusantium sed quas quibusdam corporis aliquam asperiores dignissimos reiciendis inventore, quasi soluta iste! Placeat.
                                                    Commodi laboriosam maiores officiis dicta dolores quidem ducimus accusantium sed quas quibusdam corporis aliquam asperiores dignissimos reiciendis inventore, quasi soluta iste! Placeat.
                                                    Commodi laboriosam maiores officiis dicta dolores quidem ducimus accusantium sed quas quibusdam corporis aliquam asperiores dignissimos reiciendis inventore, quasi soluta iste! Placeat.
                                                    Commodi laboriosam maiores officiis dicta dolores quidem ducimus accusantium sed quas quibusdam corporis aliquam asperiores dignissimos reiciendis inventore, quasi soluta iste! Placeat.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
		</>
	);
}

export default Services;
